import React, { useState, useEffect, useRef } from 'react'
import axios from '../../util/axios'
import { wxConfig, handleLocationPath, getAliUtoken } from '../../util/utils'
import { useDispatch } from 'react-redux'
import Template1 from './components/template1'
import Template2 from './components/template2'
import Loading from './components/loading'
import Ad from './components/ad'
import Pay from '../pay'
import { Toast } from 'antd-mobile'

let lookAd = false
// import DrawLottery from '../../components/drawLottery'
function Index() {
  const dispatch = useDispatch()
  const { sn, wifi_id, macAddress, deviceId, channelId, timestamp, sign, sign_ver } = handleLocationPath()
  const [shopInfo, setShopInfo] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [looked, setLooked] = useState(true)

  if (macAddress && deviceId && channelId) {
    sessionStorage.setItem('macAddress', macAddress)
    sessionStorage.setItem('deviceId', deviceId)
    sessionStorage.setItem('channelId', channelId)
  }
  let getShopInfo = () => {
    axios
      .post('/JuTwitter/Page/index', {
        wifi_id: wifi_id
      })
      .then((res) => {
        setIsLoading(false)
        if (res.code === 0) {
          let result = res.result
          let wifiId = sessionStorage.getItem('wifi_id')
          let shop_vr_banners = result.shop_info.shop_vr_banners
          if ((result.shop_info.style_type == 1 || result.shop_info.style_type > 2)) {
            if (result.wifi_appid) {
              if (wifiId) {
                result.wifi_appid.path = `${result.wifi_appid.path}.html?sn=${localStorage.getItem('sn')}&wifi_id=${wifiId}`
                result.scan_code_appid.path = `${result.scan_code_appid.path}.html?sn=${localStorage.getItem('sn')}&wifi_id=${wifiId}`
              } else {
                result.wifi_appid.path = `${result.wifi_appid.path}.html?sn=${localStorage.getItem('sn')}`
                result.scan_code_appid.path = `${result.scan_code_appid.path}.html?sn=${localStorage.getItem('sn')}`
              }
            }
            dispatch({ type: 'setShowTabbar', data: !1 })
            // wxConfig()
          } else {
            dispatch({ type: 'setShowTabbar', data: !0 })
          }
          shop_vr_banners.map(async (item) => {
            if (item.moded) {
              await axios.post('/JuTwitter/Page/' + item.moded).then((res) => {
                if (res.code == 0) {
                  if (item.changetype == 2) {
                    item.original_id = res.result.original_id
                    item.page_path = res.result.we_app_info.page_path
                  } else {
                    item.link = res.result
                  }
                }
              })
            }
          })
          if (result.deviceId) {
            sessionStorage.setItem('deviceId', result.deviceId)
          }
          if (result.embedding_link) {
            sessionStorage.setItem('embedding_link', result.embedding_link)
          }
          if (wifi_id) {
            axios.post('/JuTwitter/Wifi/index', { wifi_id: wifiId })
          }
          setShopInfo(result)
        }
      })
  }
  //看完广告
  const finishAd = () => {
    console.log('Ad');
    setLooked(true)
    getShopInfo()
	jili()
  }
// 激励
  const jili = ()=>{
	 axios.post('/JuTwitter/Wifi/index', { macAddress, deviceId, channelId, timestamp, sign, sign_ver}).then(res => {
      if (res.code !== 0) {
        Toast.show({
          content: res.msg
        })
      }
    })
  }

  const firstLoad = async () => {
    let is_need_wifi = await getAliUtoken()
    setIsLoading(false)
	 let isCancel = sessionStorage.getItem('isCancel')
    setLooked(is_need_wifi == 1 || isCancel? true : false)
    if (is_need_wifi == 1 || isCancel) getShopInfo();
  }

  useEffect(() => {
    let browser = navigator.userAgent.toLowerCase()
    if (sn) localStorage.setItem('sn', sn)
    if (wifi_id) sessionStorage.setItem('wifi_id', wifi_id)
    if (browser.includes('micromessenger')) {
      setIsLoading(false)
      setLooked(true)
      getShopInfo();
    } else {
      firstLoad()
    }

  }, [])
  return (
    <>
      {isLoading ? (
        <Loading />
      ) : !looked ? (
        <Ad onFinish={finishAd} />
      ) : (
        <>
          {shopInfo?.shop_info?.style_type == 1 || shopInfo?.shop_info?.style_type > 2 ? <Template2 info={shopInfo} /> : null}

          {shopInfo?.shop_info?.style_type == 2 ? <Pay /> : null}
          {/* {!sn && shopInfo.shop_info && Math.floor(Math.random() * 10 + 1) == 1 ? <DrawLottery /> : null} */}
        </>
      )}
    </>
  )
}

export default Index
